import {uiPartCreateNamespacedParts} from "@wix/devzai-utils-common";

export const DoppeActionTypeWidgetContentLayoutNewParts = uiPartCreateNamespacedParts('DoppeActionTypeWidgetContentLayoutNewParts', {
    Content: 'Content',
    Sections: 'Sections'
})